/**
 * 会议管理 - 会议创建
 *
 * @file create.js
 * @author yangwei(yangwei14@baidu.com)
 */
import _ from 'lodash';
import {Component} from 'san';
import {Button, TextBox, CheckBox} from '@baiducloud/bce-ui';

import GlobalHint from '../../components/global-hint';
import {asPage} from '../../helper';
import {html} from '../../common/raw';
import {redirect, formatTimeNoYear, isBrowserSupport} from '../../common/utils';
import client from '../../../client';

import noMeetingImgUrl from '../../../../assert/no-meeting.png';
import browserImgUrl from '../../../../assert/browser.png';
import loadingImgUrl from '../../../../assert/loading.gif';

const RoomStatus = {
    '3': {
        joinable: false,
        msg: '会议已锁定'
    },
    '4': {
        joinable: false,
        msg: '会议已满'
    },
    '5': {
        joinable: false,
        msg: '会议已结束'
    },
    '6': {
        joinable: false,
        msg: '会议已取消'
    }
};

@asPage('/meeting/join')
export default class extends Component {
    /*eslint-disable*/
    static template = html`
    <template>
        <global-hint img="${loadingImgUrl}" s-if="loading" />

        <global-hint img="${noMeetingImgUrl}" s-elif="globalError">
            {{globalError}}
        </global-hint>

        <global-hint img="${browserImgUrl}" s-elif="!isBrowserSupport">
            <div>
                <a class="download-link" href="https://www.google.cn/intl/zh-CN/chrome/" target="_blank">下载新版Chrome</a>
                <span>当前浏览器版本不支持，推荐您使用新版Chrome</span>
            </div>
        </global-hint>

        <div class="list-content meeting-join" s-else>
            <div class="create-detail">
                <div class="detail-item">
                    <div class="detail-label">会议主题：</div>
                    <div class="detail-value ellipsis" title="{{data.room_content.room_name}}">{{data.room_content.room_name}}</div>
                </div>

                <div class="detail-item">
                    <div class="detail-label">会议时间：</div>
                    <div class="detail-value">{{data | formatTimeRange}}</div>
                </div>

                <div class="detail-item">
                    <div class="detail-label">会议地点：</div>
                    <div class="detail-value ellipsis" title="{{data.room_content.room_site}}">{{data.room_content.room_site || '-'}}</div>
                </div>
            </div>

            <ui-textbox
                class="input-name"
                limit-length="{{20}}"
                placeholder="请输入姓名"
                value="{= username =}"/>

            <ui-button
                class="join-btn"
                on-click="joinMeeting"
                disabled="{{!joinStatus.joinable}}"
                skin="default"
            >
                {{joinStatus.msg}}
            </ui-button>

            <ui-checkbox on-change="changeStatus($event, 'camera', 'gVideoMuted')" checked="{=gVideoMuted=}" title="开启摄像头入会" />
            <ui-checkbox on-change="changeStatus($event, null, 'gMuted')" checked="{=gMuted=}" title="开启麦克风入会" />
            <div  s-if="notAllowed" class="error-tip">
                当前摄像头和麦克风未授权，无法加入会议
            </div>
            <div class="text-grey">
                加入会议前请输入您的姓名并检查摄像头、麦克风状态
            </div>
            <div class="video-con">
                <img
                    s-if="!gVideoMuted && !notAllowed"
                    class="video-icon"
                    src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMzJweCIgaGVpZ2h0PSIzMnB4IiB2aWV3Qm94PSIwIDAgMzIgMzIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDU2LjMgKDgxNzE2KSAtIGh0dHBzOi8vc2tldGNoLmNvbSAtLT4KICAgIDx0aXRsZT7liIblsY8t5pGE5YOP5aS0LeWFszwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxnIGlkPSLpobXpnaItMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IndlYuinhumikeS8muiuri3nvZHpobUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zNDEuMDAwMDAwLCAtNDEzMy4wMDAwMDApIj48L2c+CiAgICAgICAgPGcgaWQ9IldpbuinhumikeS8muiuruWIh+WbviIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIwMS4wMDAwMDAsIC0zMzYuMDAwMDAwKSIgZmlsbD0iIzg0OEI5OSI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0yMDguNDk5NTI3LDM0My4xMjEwNzYgTDIyMy4xMTg0MzEsMzQzLjEyMTA3NiBDMjIzLjg2MjYyOCwzNDMuMTIxMDc2IDIyNC40NjU5MTgsMzQzLjcyMzM4NCAyMjQuNDY1OTE4LDM0NC40NjYzNjggTDIyNC40NjU5MTgsMzQ5LjI5MTQ4IEwyMzMsMzQ1LjI3MzU0MyBMMjMzLDM2MC4zNDA4MDcgTDIyNC40NjU5MTgsMzU2LjMyMjg3IEwyMjQuNDY1OTE4LDM1OS4yMjkyNSBMMjMwLjQ2NDcyNiwzNjUuMjgxMzI4IEMyMzAuODU3MzI0LDM2NS42Nzc0MTIgMjMwLjg1Mzk3MywzNjYuMzE2MjQ3IDIzMC40NTcyNDMsMzY2LjcwODIwNSBDMjMwLjA2MDUxMiwzNjcuMTAwMTY0IDIyOS40MjA2MzUsMzY3LjA5NjgxOSAyMjkuMDI4MDM3LDM2Ni43MDA3MzUgTDIwMS4yOTIyNzEsMzM4LjcxODY3MiBDMjAwLjg5OTY3MywzMzguMzIyNTg4IDIwMC45MDMwMjMsMzM3LjY4Mzc1MyAyMDEuMjk5NzU0LDMzNy4yOTE3OTUgQzIwMS42OTY0ODQsMzM2Ljg5OTgzNiAyMDIuMzM2MzYxLDMzNi45MDMxODEgMjAyLjcyODk1OSwzMzcuMjk5MjY1IEwyMDguNDk5NTI3LDM0My4xMjEwNzYgWiBNMjIwLDM2MiBMMjA0LjM0MjEwNSwzNjIgQzIwMy42MDA4ODEsMzYyIDIwMywzNjEuNDA1Mzc4IDIwMywzNjAuNjcxODc1IEwyMDMsMzQ1IEwyMjAsMzYyIFoiIGlkPSLlvaLnirYiPjwvcGF0aD4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="/>
                <img
                    s-if="!gMuted && !notAllowed"
                    class="audio-icon"
                    src="data:image/svg+xml;base64,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"/>
                <div s-if="!notAllowed" id="webcamera"></div>

                <div s-if="notAllowed" class="not-allow">
                    <div class="header">摄像头和麦克风未授权</div>
                    <div class="text">
                        1.需要许可才能访问您的摄像头和⻨克⻛。单击浏览器地址中的摄像头按钮，并允许访问
                    </div>

                    <div class="text">
                        2.Mac系统如果还是无法使用请打开【系统偏好设置】-> 【安全性与隐私】->【隐私】选项中确认【摄像头】【麦克风】【屏幕录制】已经勾选上浏览器访问授权，确认以上操作后点击刷新重试
                    </div>
                </div>
            </div>
        </div>
    `;

    static components = {
        'ui-textbox': TextBox,
        'ui-button': Button,
        'ui-checkbox': CheckBox,
        'global-hint': GlobalHint
    }

    static filters = {
        formatTimeRange: data => {
            if (data && data.room_etime){
                return `${formatTimeNoYear(data.room_stime * 1000)}-${formatTimeNoYear(data.room_etime * 1000)}`
            }
            else if (_.get(data, 'room_content.room_time_range')) {
                const arr = data.room_content.room_time_range.split(' - ');
                return `${formatTimeNoYear(arr[0])}-${formatTimeNoYear(arr[1])}`;
            }
            return '-';
        }
    }

    static computed = {
        joinStatus() {
            const data = this.data.get('data');
            const notAllowed = this.data.get('notAllowed')
            const username = this.data.get('username');
            if (data && RoomStatus[data.room_status + '']) {
                return RoomStatus[data.room_status + ''];
            }
            if (notAllowed) {
                return {
                    joinable: false,
                    msg: '摄像头和麦克风未授权'
                }
            }
            return {
                joinable: !!username,
                msg: '加入会议'
            };
        }
    }

    /*eslint-enable*/
    initData() {
        return {
            loading: true,
            isBrowserSupport: isBrowserSupport(),
            username: '',
            notAllowed: false,
            gUsingAudio: true,
            gUsingVideo: true,
            gVideoMuted: localStorage.getItem('gVideoMuted') === 'true', // 本地摄像头状态，默认关
            gMuted: localStorage.getItem('gMuted') ? localStorage.getItem('gMuted') === 'true' : true // 本地麦克风状态，默认开
        };
    }
    attached() {
        // (gMuted, '音频:  true静音  false取消静音', gVideoMuted, '视频: true打开  false关闭');
        const query = this.data.get('route.query');
        query.r && this.getData(query.r);
        query.microphone && this.data.set('gMuted', query.microphone === 'false');
        query.camera && this.data.set('gVideoMuted', query.camera === 'true');
        query.name && this.data.set('username', query.name);
        // eslint-disable-next-line
        let _this = this;
        // eslint-disable-next-line
        window.BRTC_GetVideoDevices({
            success: function (data) { //eslint-disable-line
                _.each(data, item => {
                    item.kind === 'audioinput' && _this.data.set('localAudioInDevice', item.deviceId);
                    item.kind === 'videoinput' && _this.data.set('localVideoDevice', item.deviceId);
                    item.kind === 'audiooutput' && _this.data.set('localAudioOutDevice', item.deviceId);
                });
                _this.initBRTCSDK();
            }
        });
    }
    initBRTCSDK() {
        if (!this.sdkInitable || this.sdkInited) {
            return;
        }
        this.sdkInited = true;
        let {localVideoDevice, gUsingVideo, gUsingAudio} = this.data.get();
        // eslint-disable-next-line
        window.BRTC_DeviceTest_Start({
            localvideoviewid: 'webcamera', // 本地存放视频窗口的dom  id
            mirrorlocalvideo: true,
            usingvideo: gUsingVideo, // 是否需要浏览器的摄像头弹框
            usingaudio: gUsingAudio, // 是否需要浏览器的麦克风弹框
            videodeviceid: localVideoDevice, // 摄像头设备id
            audiodeviceid: null, // 音频输入设备id
            audiooutputdeviceid: null, // 音频输出设备id
            success: () => {
                if (!this.data.get('gVideoMuted')) {
                    window.BRTC_DeviceTest_MuteCamera(true);// eslint-disable-line
                }
                // this.watchOutInDevice(); // 监听音频插入、拔出
            },
            error: error => {
                let newError = error + '';
                if (newError.includes('NotAllowedError')) {
                    // 摄像头未授权
                    // this.isShowInfo = false;
                    this.isEmpower = false;
                    this.data.set('notAllowed', true);
                }
            }
        });
    }
    async getData(r) {
        this.data.set('loading', true);
        this.data.set('globalError', false);
        try {
            const data = await client.getMettingDetail({
                r,
                join: ''
            }, {
                'x-silent': true
            });
            if (data.status === 422) {
                this.data.set('globalError', '会议不存在');
            } else {
                this.data.set('data', data.data);
                this.data.set('paramr', data.data.room_url_path);
                this.nextTick(() => {
                    this.sdkInitable = true;
                    this.initBRTCSDK();
                });
            }
        } catch (ex) {
            this.data.set('globalError', '会议请求信息失败');
        }
        this.data.set('loading', false);
    }
    joinMeeting() {
        let {gMuted, gVideoMuted, username, paramr} = this.data.get();
        gMuted = gMuted ? 'false' : 'true';
        gVideoMuted = gVideoMuted ? 'true' : 'false';
        const str = `https://flowkit-rtc.baidu.com/yun/#/join?r=${paramr}&microphone=${gMuted}&camera=${gVideoMuted}&name=${username}&lang=${LANGUAGE}`;
        location.href = str;
    }
    changeStatus({value}, type, key) {
        type === 'camera'
        ? this.getCameraAuth(value)
        : this.getMicroPhoneAuth(value);
        localStorage && localStorage.setItem(key, value);
    }
    getCameraAuth(onOff) {
        window.BRTC_DeviceTest_MuteCamera(!onOff); //eslint-disable-line
    }
    getMicroPhoneAuth(onOff) {
        window.BRTC_DeviceTest_MuteMicphone(!onOff); //eslint-disable-line
    }
    returnList() {
        redirect('#/meeting/list');
    }
}
